// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","300":"component---src-templates-introduction-tsx","783":"component---src-pages-edition-tsx"}[chunkId] || chunkId) + "-" + {"108":"f6755ceff8cd8e308c4f","223":"474d3f9e79724c8ace42","300":"a6d9dfd81b955e7e1bb3","452":"3d8f12181c10ba474ac2","783":"f866dffd311d261b637a"}[chunkId] + ".js";
};